import { render, staticRenderFns } from "./addLeveModal.vue?vue&type=template&id=5dedb3cf&scoped=true"
import script from "./addLeveModal.vue?vue&type=script&lang=js"
export * from "./addLeveModal.vue?vue&type=script&lang=js"
import style0 from "./addLeveModal.vue?vue&type=style&index=0&id=5dedb3cf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dedb3cf",
  null
  
)

export default component.exports